import { Step, Stepper, Typography } from '@mui/material';
import { useCallback } from 'react';

import { GenericStepperProps } from './GenericStepper.interface';
import {
  StepperContainer,
  StepperHeader,
  StyledStepConnector,
  StyledStepLabel,
} from './GenericStepper.styles';

export const GenericStepper = ({
  steps,
  activeStep,
  stepsCompletedMessage,
  titleVariant = 'h1',
  hideStepperHeader = false,
  connectorStyleType = 'dashed',
  isAlternativeLabel,
  headerPadding,
}: GenericStepperProps) => {
  const getStepperTitle = useCallback(() => {
    if (typeof steps[activeStep].title === 'string') {
      return (
        <Typography
          variant={titleVariant}
          textAlign="center"
          gutterBottom
          marginTop={5}>
          {steps[activeStep].title}
        </Typography>
      );
    }

    return steps[activeStep].title;
  }, [activeStep, steps, titleVariant]);

  return (
    <StepperContainer>
      {!hideStepperHeader && (
        <StepperHeader padding={headerPadding}>
          <Stepper
            activeStep={activeStep}
            {...(!isAlternativeLabel && { alternativeLabel: true })}
            connector={
              <StyledStepConnector $borderStyle={connectorStyleType} />
            }>
            {steps.map((step, index) => (
              <Step key={index}>
                <StyledStepLabel>{step.name}</StyledStepLabel>
              </Step>
            ))}
          </Stepper>

          {activeStep < steps.length
            ? getStepperTitle()
            : stepsCompletedMessage}
        </StepperHeader>
      )}
      {activeStep < steps.length && steps[activeStep].component}
      {activeStep < steps.length && steps[activeStep].footer}
    </StepperContainer>
  );
};
